export default __webpack_public_path__ + "static/media/moviesList.d2bcbf3f.jpeg";